import { fetcher } from '../utils'
import { ComponentUserTransferVO } from '@repo/types'

export default async (input: ComponentUserTransferVO): Promise<void> => fetcher(`/api/transfer/chat`, 'POST', input)
